(function() { module.exports = window["eventespresso"]["ioc"]; }());